import FeedBack from './feedback';

export default FeedBack;
